import React, { Component } from 'react';
import { translate } from 'react-i18next';
import ReactGA from 'react-ga';
import { Cross } from '../icons';

class FilterResults extends Component {
  constructor(props) {
    super(props);
    this.initializeFilters();
  }
  state = {
    hasChanges: false,
    hasSelections: false
  };
  filteredApplications = [];
  initialFilteredApplications = [];
  results = [];
  applications = this.props.applications;

  componentDidUpdate(prevProps, prevState) {
    let checkedElements = [];

    for (var element of document.querySelectorAll('.selects input')) {
      if (element.checked) checkedElements.push(element);
    }

    // If no filters are checked when opening, ensure filteredApplications is in sync
    if (this.state.showContent !== prevState.showContent && checkedElements.length === 0) {
      this.filteredApplications = [];
      this.checkForChanges();
    }
  }

  initializeFilters = () => {
    // Start with empty - when empty, show all products
    this.filteredApplications = [];

    // Store initial state - empty array means show all
    this.initialFilteredApplications = [];
  };

  checkForChanges = () => {
    const hasChanges =
      this.filteredApplications.length !== this.initialFilteredApplications.length ||
      !this.filteredApplications.every(id => this.initialFilteredApplications.includes(id));

    // Check if any checkboxes are actually checked
    let checkedCount = 0;
    for (var element of document.querySelectorAll('.selects input')) {
      if (element.checked) checkedCount++;
    }
    const hasSelections = checkedCount > 0;

    this.setState({ hasChanges, hasSelections });
  };

  handleChange = (e) => {
    if (e.target.checked) {
      this.filteredApplications.push(e.target.value);
    } else {
      const index = this.filteredApplications.indexOf(e.target.value);
      this.filteredApplications.splice(index, 1);
    }
    this.checkForChanges();
  };

  selectAll = () => {
    this.filteredApplications = [];

    for (var element of document.querySelectorAll('.selects input')) {
      element.checked = true;
    }

    for (var application of this.applications) {
      this.filteredApplications.push(application.applications[0].id);
    }

    this.checkForChanges();
  };

  deSelectAll = () => {
    // Only allow deselecting if there are selections
    if (this.filteredApplications.length === 0) {
      return;
    }

    this.filteredApplications = [];

    for (var element of document.querySelectorAll('.selects input')) {
      element.checked = false;
    }

    this.checkForChanges();
  };

  updateResults = () => {
    this.results = [];

    // If no filters selected, show all
    if (this.filteredApplications.length === 0) {
      this.results = [...this.applications];
    } else {
      // Show only filtered items
      for (var element of this.applications) {
        if (this.filteredApplications.includes(element.applications[0].id)) {
          this.results.push(element);
        }
      }
    }

    this.props.updateResults(this.results);
    // Update initial state after applying filters
    this.initialFilteredApplications = [...this.filteredApplications];
    this.setState({ showContent: false, hasChanges: false });
  };

  render() {
    const { t, selectedFamily } = this.props;

    const content = (
      <div className={this.state.showContent ? 'content' : 'content hidden'}>
        <div className="select-content">
          <div className={`group-select ${!this.state.hasSelections ? 'disabled' : ''}`}>
            <p onClick={this.deSelectAll}>{t('filter_results.deselect_all')}</p>
          </div>
          <div className="selects">
            {this.applications.map((application) => {
              return (
                <label className="select" key={application.applications[0].id}>
                  <input
                    type="checkbox"
                    value={application.applications[0].id}
                    onChange={this.handleChange}
                  />
                  <span>{application.name}</span>
                </label>
              );
            }, this)}
          </div>
        </div>
        <div className="button-container">
          <a className="close" onClick={() => this.setState({ showContent: false })}>
            <Cross size="10px" /> {t('filter_results.close')}
          </a>
          <button
            onClick={() => {
              if (this.state.hasChanges) {
                this.updateResults();
                ReactGA.event({
                  category: this.props.i18n.language,
                  action: selectedFamily,
                  label: 'Filter Update',
                });
              }
            }}
            className="button"
            disabled={!this.state.hasChanges}
          >
            {t('filter_results.update_results')}
          </button>
        </div>
      </div>
    );

    return (
      <section className="filters">
        <div
          onClick={() => this.setState({ showContent: !this.state.showContent })}
          className={this.state.showContent ? 'tab-name active' : 'tab-name'}
        >
          {t('filter_results.filter_applications')}
        </div>
        {content}
      </section>
    );
  }
}

export default translate('translations')(FilterResults);
